class s {
    activeKey="";
    _subscriptions=new Set;
    _run() {
        this._subscriptions.forEach((s => s()));
    }
    setActiveKey(s) {
        this.activeKey = s, this._run();
    }
    on=s => (this._subscriptions.add(s), () => this._subscriptions.delete(s));
}

export { s as default };
//# sourceMappingURL=index.js.map
